/*
 * Copyright (c) 2023. All rights reserved by kudiyar
 *
 */

import {useState} from "react";

const Product = (props) => {
    var product = props.prod
    var [amount, setAmount] = useState(1)
    return(
        <div key={product.id} style={{maxWidth: "500px"}}>
            <div className="card mb-4">
                <div id="card" data-id={product.id}>

                    <h4 className="item-title">{product.title}</h4>
                    <div className='product-box'>
                        <img className="product-img" src={`http://localhost:8083/photo/JPEG/${product.img}`} alt={product.title} />
                    </div>
                    <div className="card-body text-center">
                        <div className='subscr'>
                            <p>{product.subscription}</p>
                        </div>
                        <div className="price">
                            <div data-items-in-box className="inbox">
                                <p>В наличии: 5</p>
                            </div>
                            <div className="price__weight">{product.weight}г.</div>
                            <div className="price__currency">{product.price} ₽</div>
                        </div>
                        <div className="details-wrapper">
                            <div className="hex counter-wrapper">
                                <button className="items__control" onClick={()=>{
                                    if (amount !==  1){
                                    setAmount(amount - 1)
                                        }

                                }}>-</button>
                                <div className="items__current">{amount}</div>
                                <button className="items__control" onClick={()=>{
                                    if (amount >= 1){

                                        setAmount(amount +1)}}}>+</button>
                            </div>
                            <button
                                onClick={() => {
                                    // Check if the product is already in the cart
                                    const existingProductIndex = props.ci.findIndex((item) => item.id === product.id);

                                    if (existingProductIndex !== -1) {
                                        // If the product is in the cart, increase its quantity
                                        const updatedCart = [...props.ci];
                                        updatedCart[existingProductIndex].quantity += amount;
                                        props.sp(updatedCart);
                                    } else {
                                        // If the product is not in the cart, add it with a quantity of 1
                                        const updatedCart = [...props.ci, { ...product, quantity:amount }];
                                        props.sp(updatedCart);
                                    }
                                }}
                                type="button"
                                className="card-button"
                            >
                                В корзину
                            </button>

                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
export default Product